export const CURRENT_ROOT_ENTITY_URL ="/current-root-entity";
export const DOWNLOAD_LOGO_ENTITY = "/download-logo-entity";
